import React, { useState } from 'react';
import { ArrowUpDown, Building2, MapPin, ArrowLeft, ArrowRight } from 'lucide-react';

interface AccessibilityStepProps {
  value: {
    accessibility: {
      floor: number;
      elevator: boolean;
      narrowStreet: boolean;
    };
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const AccessibilityStep: React.FC<AccessibilityStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleAccessibilityChange = (field: keyof typeof value.accessibility, newValue: any) => {
    onChange('accessibility', {
      ...value.accessibility,
      [field]: newValue
    });
  };

  const handleFocus = () => {
    setIsFocused(true);
    handleAccessibilityChange('floor', '');
  };

  return (
    <div className="space-y-6">
      {/* Boutons de navigation compacts en haut */}
      <div className="flex justify-between items-center pb-4 border-b border-neutral-200">
        <h2 className="text-base font-semibold text-primary">Accessibilité</h2>
        <div className="flex items-center gap-2 ml-4">
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="px-3 py-2 text-sm font-medium text-neutral-700 bg-white border border-neutral-300 rounded-lg hover:bg-neutral-50 transition-colors flex items-center gap-1"
            >
              <ArrowLeft className="h-4 w-4" />
              Précédent
            </button>
          )}
          <button
            type="button"
            onClick={onNext}
            className="px-3 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-dark transition-colors flex items-center gap-1"
          >
            Suivant
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-neutral-700 mb-2">
          Étage
        </label>
        <div className="flex items-center space-x-2">
          <input
            type="number"
            value={isFocused ? value.accessibility.floor || '' : value.accessibility.floor || 0}
            onChange={(e) => handleAccessibilityChange('floor', parseInt(e.target.value) || '')}
            onFocus={handleFocus}
            onBlur={() => setIsFocused(false)}
            min="0"
            className="input w-32"
            placeholder="0"
          />
          <span className="text-sm text-neutral-500">(0 = rez-de-chaussée)</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => handleAccessibilityChange('elevator', !value.accessibility.elevator)}
          className={`
            card flex items-center p-4 transition-all
            ${value.accessibility.elevator ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
          `}
        >
          <Building2 className={`h-5 w-5 mr-2 ${value.accessibility.elevator ? 'text-primary' : 'text-neutral-600'}`} />
          <span className={value.accessibility.elevator ? 'text-primary' : 'text-neutral-700'}>
            Ascenseur
          </span>
        </button>

        <button
          type="button"
          onClick={() => handleAccessibilityChange('narrowStreet', !value.accessibility.narrowStreet)}
          className={`
            card flex items-center p-4 transition-all
            ${value.accessibility.narrowStreet ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
          `}
        >
          <MapPin className={`h-5 w-5 mr-2 ${value.accessibility.narrowStreet ? 'text-primary' : 'text-neutral-600'}`} />
          <span className={value.accessibility.narrowStreet ? 'text-primary' : 'text-neutral-700'}>
            Rue étroite
          </span>
        </button>
      </div>
    </div>
  );
};

export default AccessibilityStep;